@if (casesModalLoading) {
    <div class="page-loader">
        <div class="loader-card">
            <span class="loader-brand">E.A.S.Y.&nbsp;<span class="brand-accent">Liens</span></span>
            <div class="loader-divider"></div>
            <div class="spinner"></div>
            <span class="loader-message">Loading…</span>
        </div>
    </div>
}

<div class="page-container">
    <div class="dashboard-content">
        <!-- Case Lookup/Search (Admin only) -->
        @if (isAdmin) {
            <div class="dashboard-search-bar">
                <hugeicons-icon [icon]="searchIcon" [size]="16" class="search-icon"></hugeicons-icon>
                <input
                    type="text"
                    placeholder="Search by client name, attorney name, CAS-004..."
                    [(ngModel)]="caseSearchQuery"
                    (keyup.enter)="searchCase()"
                />
                <button class="search-btn" (click)="searchCase()" [disabled]="searchLoading">
                    @if (searchLoading) {
                        <span class="btn-spinner"></span>
                        Searching...
                    } @else {
                        Search
                    }
                </button>
            </div>
        }

        <!-- Inquiries - 3 Column Horizontal -->
        @if (enquiryPhase) {
            <div class="phase-card phase-card-wide" [ngClass]="enquiryPhase.colorClass">
                <div class="phase-card-header">
                    <div class="phase-card-header-left">
                        <div class="phase-icon-badge">
                            <hugeicons-icon [icon]="enquiryPhase.icon" [size]="18" color="currentColor"></hugeicons-icon>
                        </div>
                        <span class="phase-title">{{ enquiryPhase.title }}</span>
                    </div>
                    @if (!isAdmin) {
                        <button class="btn btn-sm btn-primary" (click)="navigateToAddEnquiry()">
                            <hugeicons-icon [icon]="addIcon" [size]="16" color="#ffffff"></hugeicons-icon>
                            Add Inquiry
                        </button>
                    }
                </div>
                <div class="phase-card-body-horizontal">
                    @for (status of enquiryPhase.statuses; track status.label) {
                        <div class="phase-stat-item clickable" (click)="openCasesModal(status.key)">
                            <span class="phase-count">{{ status.count }}</span>
                            <span class="phase-label">{{ status.label }}</span>
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Offers, Resolutions, Closures - 3 Column Row -->
        <div class="phase-board-bottom">
            @for (phase of bottomPhases; track phase.title) {
                <div class="phase-card" [ngClass]="phase.colorClass">
                    <div class="phase-card-header">
                        <div class="phase-card-header-left">
                            <div class="phase-icon-badge">
                                <hugeicons-icon [icon]="phase.icon" [size]="18" color="currentColor"></hugeicons-icon>
                            </div>
                            <span class="phase-title">{{ phase.title }}</span>
                        </div>
                    </div>
                    <div class="phase-card-body">
                        @for (status of phase.statuses; track status.label) {
                            <div class="phase-row clickable" (click)="openCasesModal(status.key)">
                                <span class="phase-label">{{ status.label }}</span>
                                <span class="phase-count">{{ status.count }}</span>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<!-- Search Results Modal -->
<app-modal
    [isOpen]="showSearchResultsModal"
    [title]="'Search Results'"
    [size]="'lg'"
    [showCloseButton]="true"
    [showFooter]="false"
    (close)="closeSearchResultsModal()">
    @if (searchLoading) {
        <div class="search-loading">Searching...</div>
    } @else if (searchResults.length === 0) {
        <app-no-data title="No Cases Found" description="No cases matched your search. Try a different keyword."></app-no-data>
    } @else {
        <div class="search-results-table-wrap">
            <table class="search-results-table">
                <thead>
                    <tr>
                        <th>Case Code</th>
                        <th>Client Name</th>
                        <th>Attorney</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for (result of searchResults; track result.id) {
                        <tr>
                            <td>{{ result.case_code }}</td>
                            <td>{{ result.client_name }}</td>
                            <td>{{ result.attorney_name }}</td>
                            <td>
                                <span class="search-status-badge">{{ getProgressLabel(result.case_progress) }}</span>
                            </td>
                            <td>
                                <button class="btn-view-case" (click)="viewCase(result.id)">View</button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</app-modal>

<!-- Cases Listing Modal -->
<app-modal
    [isOpen]="showCasesModal"
    [title]="casesModalTitle"
    [size]="'xl'"
    [showCloseButton]="true"
    [showFooter]="false"
    (close)="closeCasesModal()">
    @if (casesModalData.length === 0) {
        <app-no-data title="No Cases Found" description="There are no cases in this category at the moment.">
            @if (!isAdmin && casesModalType === 'enquiry') {
                <button class="btn btn-md btn-primary" style="margin-top: 16px;" (click)="navigateToAddEnquiry()">Add Inquiry</button>
            }
        </app-no-data>
    } @else if (casesModalType === 'enquiry') {
        <div class="cases-modal-table-wrap">
            <table class="cases-modal-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Client Name</th>
                        <th>Injury Type</th>
                        <th>Incident Date</th>
                        <th>Attorney</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of casesModalData; track item.case_enquiry_id) {
                        <tr (click)="viewEnquiryFromModal(item.case_enquiry_id)">
                            <td><span class="cases-modal-code">ENQ-{{ item.case_enquiry_id }}</span></td>
                            <td class="cases-modal-name">{{ item.client_name }}</td>
                            <td>{{ item.basic_injury_type }}</td>
                            <td>{{ item.incident_date | date: 'mediumDate' }}</td>
                            <td>{{ item.attorney_name }}</td>
                            <td class="cases-modal-action">
                                <button class="btn-view-case" (click)="viewEnquiryFromModal(item.case_enquiry_id); $event.stopPropagation()">View</button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    } @else {
        <div class="cases-modal-table-wrap">
            <table class="cases-modal-table">
                <thead>
                    <tr>
                        <th>Case Code</th>
                        <th>Client Name</th>
                        <th>Attorney</th>
                        <th>Hospital</th>
                        <th>Lien Balance</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of casesModalData; track item.id) {
                        <tr (click)="viewCaseFromModal(item.id)">
                            <td><span class="cases-modal-code">{{ item.case_code }}</span></td>
                            <td class="cases-modal-name">{{ item.client_name }}</td>
                            <td>{{ item.attorney_name }}</td>
                            <td>{{ item.hospital }}</td>
                            <td class="cases-modal-balance">{{ item.lien_balance | currency }}</td>
                            <td class="cases-modal-action">
                                <button class="btn-view-case" (click)="viewCaseFromModal(item.id); $event.stopPropagation()">View</button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</app-modal>

<!-- Inquiry Detail Modal -->
@if (selectedEnquiry) {
    <app-case-enquiry-details
        [enquiry]="selectedEnquiry"
        (close)="closeEnquiryDetailModal()"
        (statusChanged)="onEnquiryStatusChanged()">
    </app-case-enquiry-details>
}
